import React from 'react';
import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';
import { View, Text, StyleSheet, Image } from 'react-native';
import { useSelector } from 'react-redux';

const Services = () => {

	const isLandscape = useSelector( state => state.globals.isLandscape);

	const styles = StyleSheet.create({
		container: {
			height: isLandscape ? '80vh' : undefined,
			width: '100%',
			padding: !isLandscape ? 10 :'15vw',
			flexDirection: !isLandscape ? 'column' : 'row',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: COLORS.white,
		},
		columnContainer: {
			marginHorizontal: 15,
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
		},
		rowContainer: {
			marginVertical: 20,
			flexDirection: 'row',
		},
		servicesImageContainer: {
			height: 90,
			width: 120,
		},
		textContainer: {
			justifyContent: 'center',
			alignItems: 'center',
			textAlign: 'center',
		},
		servicesHeaderText: {
			fontFamily: FONTS.bold,
			fontSize: 30,
			color: COLORS.primary,
			borderBottomWidth: 2,
		},
		servicesText: {
			maxWidth: isLandscape ? '25vw' : undefined,
			fontFamily: FONTS.default,
			fontSize: FONT_SIZES.lg,
			color: COLORS.primary,
		},
		aiImage: {
			height: 160,
			width: 160,
		},
		aiText: {
			maxWidth: isLandscape ? '25vw' : undefined,
			fontFamily: FONTS.default,
			fontSize: FONT_SIZES.xxl,
			color: COLORS.dark,
			textAlign: 'center',
		},
		highlightText: {
			fontFamily: FONTS.bold,
			color: COLORS.primary,
		}
	});

	return (
		<View style={styles.container}>

			{/* Column 1 */}
			<View style={styles.columnContainer}>

				{/* Cross Platform */}
				<View style={styles.rowContainer}>
					<Image
						source={require('../../assets/images/icons/multiPlatform.png')}
						style={styles.servicesImageContainer}
						resizeMode={'contain'}
					/>
					<View style={styles.textContainer}>
						<Text style={styles.servicesHeaderText}>Cross Platform</Text>
						<Text style={styles.servicesText}>Mobile, Tablet & Desktop</Text>
					</View>
				</View>

				{/* HIPAA Compliant */}
				<View style={styles.rowContainer}>
					<View style={styles.textContainer}>
						<Text style={styles.servicesHeaderText}>HIPAA Compliant</Text>
						<Text style={styles.servicesText}>Secure, E2E Encryption</Text>
					</View>
					<Image
						source={require('../../assets/images/icons/secure.jpg')}
						style={styles.servicesImageContainer}
						resizeMode={'contain'}
					/>
				</View>

				{/* Rapid Sign Up */}
				<View style={styles.rowContainer}>
					<Image
						source={require('../../assets/images/icons/rapidSignUp.png')}
						style={styles.servicesImageContainer}
						resizeMode={'contain'}
					/>
					<View style={styles.textContainer}>
						<Text style={styles.servicesHeaderText}>Rapid Sign Up</Text>
						<Text style={styles.servicesText}>Connect in 60 Seconds</Text>
					</View>
				</View>
			</View>

			{/* Column 2 */}
			<View style={styles.columnContainer}>
				<Image
					source={require('../../assets/images/icons/ai.jpg')}
					style={styles.aiImage}
					resizeMode={'contain'}
				/>
				<View style={styles.textContainer}>
					<Text style={styles.aiText}>
						{'With just a smartphone picture, evaluate surface area with '}
						<Text style={styles.highlightText}>86%</Text>
						{' accuracy'}
					</Text>
				</View>
			</View>

			{/* Column 3 */}
			<View style={styles.columnContainer}>

				{/* Clean Interface */}
				<View style={styles.rowContainer}>
					<View style={styles.textContainer}>
						<Text style={styles.servicesHeaderText}>Clean Interface</Text>
						<Text style={styles.servicesText}>Easy to learn, Easy to Use</Text>
					</View>
					<Image
						source={require('../../assets/images/icons/healthRecord.png')}
						style={styles.servicesImageContainer}
						resizeMode={'contain'}
					/>
				</View>

				{/* Repote Monitor */}
				<View style={styles.rowContainer}>
					<Image
						source={require('../../assets/images/icons/healthMonitor.png')}
						style={styles.servicesImageContainer}
						resizeMode={'contain'}
					/>
					<View style={styles.textContainer}>
						<Text style={styles.servicesHeaderText}>Remote Monitor</Text>
						<Text style={styles.servicesText}>Connect from anywhere</Text>
					</View>
				</View>

				{/* Rapid Sign Up */}
				<View style={styles.rowContainer}>
					<View style={styles.textContainer}>
						<Text style={styles.servicesHeaderText}>EHR Integration</Text>
						<Text style={styles.servicesText}>PDF Export</Text>
					</View>
					<Image
						source={require('../../assets/images/icons/link.png')}
						style={styles.servicesImageContainer}
						resizeMode={'contain'}
					/>
				</View>
			</View>
		</View>
	);
};

export default Services;